import { createContext } from "react";
import { Persona } from "../__generated__/graphql";

const AutopilotCuratedSearchContext = createContext({
  selectedPrompt: "",
  setSelectedPrompt: (prompt: string | null) => {
    return;
  },
  upsertAutopilotCuratedSearchLoading: false,
  historicalPrompts: [] as string[],
  personas: [] as Persona[],
  setStartedGeneratingFilters: (value: boolean) => {
    return;
  },
  startedGeneratingFilters: false,
  reset: () => {
    return;
  },
} as {
  selectedPrompt: string;
  setSelectedPrompt: (prompt: string | null) => void;
  upsertAutopilotCuratedSearchLoading: boolean;
  historicalPrompts: string[];
  personas: Persona[];
  setStartedGeneratingFilters: (value: boolean) => void;
  startedGeneratingFilters: boolean;
  reset: () => void;
});

export default AutopilotCuratedSearchContext;
